import React from 'react';
import { Form, Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import TextBox from '../../../shared/components/form/TextBox';

const validate = (values) => {
  const errors = {};
  if (!values.fechaAtencionReclamos) {
    errors.fechaAtencionReclamos = 'Debe ingresar la fecha de atendimiento';
  }
  return errors;
};

const StampExamForm = ({
  materia,
  fecha,
  mode,
  handleSubmit,
  onCancel,
  submitting,
}) => (
  <Form className="form" onSubmit={handleSubmit}>
    <Row>
      <Col md={12}>
        <p>
          {mode === 'confirmGrades'
            ? (
              <>
                Se van a confirmar las notas del examen de{' '}
                <strong>{materia}</strong> del <strong>{fecha}</strong>.
              </>
            )
            : (
              <>
                Se va a sellar el examen de{' '}
                <strong>{materia}</strong> del <strong>{fecha}</strong>.
              </>
            )
          }
        </p>
        {mode === 'confirmGrades' ? (
          <p>
            La ventana de solicitud de revisión se generará automáticamente por 48 horas al confirmar las notas.
          </p>
        ) : (
          <p>
            La ventana de solicitud de revisión ya fue definida automáticamente.
          </p>
        )}
      </Col>

      {mode === 'confirmGrades' ? (
        <Col md={12}>
          <div className="form__form-group">
            <span className="form__form-group-label required">Fecha de atendimiento de reclamos</span>
            <div className="form__form-group-field">
              <Field
                name="fechaAtencionReclamos"
                component={TextBox}
                placeholder="Fecha de atendimiento"
                autoComplete="false"
                type="datetime-local"
              />
            </div>
          </div>
        </Col>
      ) : null}
    </Row>
    {mode === 'confirmGrades' ? (
      <div
        className="modal__footer"
        style={{
          marginTop: '15px',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
        }}
      >
        <button
          type="submit"
          className="btn btn-primary"
          disabled={submitting}
        >
          Si, Confirmar notas
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onCancel}
        >
          No, Volver
        </button>
      </div>
    ) : null}
  </Form>
);

StampExamForm.propTypes = {
  materia: PropTypes.string,
  fecha: PropTypes.string,
  mode: PropTypes.oneOf(['stamp', 'confirmGrades']),
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  submitting: PropTypes.bool,
};

StampExamForm.defaultProps = {
  materia: '',
  fecha: '',
  mode: 'stamp',
  onCancel: () => {},
  submitting: false,
};

export default reduxForm({
  form: 'StampExamForm',
  validate,
  enableReinitialize: true,
})(StampExamForm);
